import routeConfig from 'app/config/routes';
import routes from 'constants/routes';

const { path: analyticsPath } = routeConfig.analytics;
const { reports } = routeConfig.analytics.routes;
const reportsCreateSegment = `${reports.path}/${reports.routes.create.path}`;

function normalizePathname(pathname: string): string {
  return pathname.replace(/\/+$/, '') || '/';
}

export function isAnalyticsReportEditRoute(pathname: string): boolean {
  const segments = pathname.split('/').filter(Boolean);
  if (segments.length < 4) {
    return false;
  }

  const editIndex = segments.length - 1;

  return (
    segments[editIndex] === 'edit' &&
    /^\d+$/.test(segments[editIndex - 1]) &&
    segments[editIndex - 2] === reports.path &&
    segments[editIndex - 3] === analyticsPath
  );
}

export function isAnalyticsReportEditorRoute(pathname: string): boolean {
  return (
    pathname.endsWith(reportsCreateSegment) ||
    isAnalyticsReportEditRoute(pathname)
  );
}

export function isAnalyticsReportsListRoute(pathname: string): boolean {
  if (isAnalyticsReportEditorRoute(pathname)) {
    return false;
  }

  const reportsListPath = `/${analyticsPath}/${reports.path}`;
  return normalizePathname(pathname) === reportsListPath;
}

export type CreateReportMetricPrefill = 'template';

export interface BuildAnalyticsReportCreateUrlOptions {
  templateCode?: string;
  metricPrefill?: CreateReportMetricPrefill;
}

export function parseReportMetricPrefillQueryParam(
  value: string | null,
): CreateReportMetricPrefill | null {
  return value === 'template' ? 'template' : null;
}

export function buildAnalyticsReportCreateUrl(
  templateCodeOrOptions?: string | BuildAnalyticsReportCreateUrlOptions,
): string {
  const options =
    typeof templateCodeOrOptions === 'string'
      ? { templateCode: templateCodeOrOptions }
      : templateCodeOrOptions;

  if (!options?.templateCode && !options?.metricPrefill) {
    return routes.ANALYTICS_REPORTS_CREATE;
  }

  const params = new URLSearchParams();

  if (options.templateCode) {
    params.set('template', options.templateCode);
  }

  if (options.metricPrefill) {
    params.set('prefill', options.metricPrefill);
  }

  return `${routes.ANALYTICS_REPORTS_CREATE}?${params.toString()}`;
}

export interface CreateReportLocationState {
  returnTo?: string;
  metricPrefill?: CreateReportMetricPrefill;
}
